<template>
  <div class="commentItemPC">
    <div v-if="isEntry">
      <p class="entry">
        <span>欢迎 {{ userName }} 进入课堂</span>
      </p>
    </div>
    <div v-else>
      <p class="user">{{ userName }}：</p>
      <p class="commentCon">{{ message }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MCommentItem',
  props: {
    comment: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      messageType: {
        entry: 'ID_REMOTE_USER_JOIN',
        default: 'ID_REMOTE_USER_MSG',
        teacherEntry: 'ID_REMOTE_TEACHER_JOIN',
        teacherQuit: 'ID_LEAVE_CLASS',
        shutUp: 'ID_ALL_SHUTUP',
        ownEntry: 'ID_MYSELF_ENTRY',
        keepAlive: 'ID_KEEP_LIVE'
      }
    };
  },
  computed: {
    parseMessage() {
      const payload = this.comment.payload;
      if (payload.data) {
        return JSON.parse(payload.data);
      } else if (payload.text) {
        console.log('JSON.parse(payload.text): ', JSON.parse(payload.text));
        return JSON.parse(payload.text);
      } else {
        return '';
      }
    },
    userName() {
      return this.parseMessage ? this.parseMessage.property.realname : '';
    },
    message() {
      return this.parseMessage ? this.parseMessage.property.msg : '';
    },
    isEntry() {
      if (this.parseMessage) {
        return this.parseMessage.eventid === this.messageType.entry;
      } else {
        return false;
      }
    },
    isKeepLive() {
      if (this.parseMessage) {
        return this.parseMessage.eventid === this.messageType.keepAlive;
      } else {
        return false;
      }
    }
  },
  methods: {
    itemHandler() {
      this.$emit('itemClick', this.comment);
    }
  }
};
</script>

<style lang="less" scoped>
.commentItemPC {
  width: calc(100% - 8px);
  margin: 4px;
  font-size: 5px;
  line-height: 18px;
  height: 12px;

  > div {
    display: flex;

    .user {
      white-space: nowrap;
    }

    .commentCon {
      flex: 1;
      word-break: break-all;
    }

    .entry {
      width: 100%;
      text-align: center;
      height: 10px;

      span {
        height: 10px;
        padding: 4px;
        color: #3a6b99;
        // background-color: #1890ff;
        border-radius: 15px;
      }
    }
  }
}
</style>
